const STORAGE_KEY = 'pending_plan_change'
const MAX_AGE_MS = 1000 * 60 * 60 * 48

export type PendingPlanChange = {
  subscriptionId: string
  targetPlanId?: string | null
  createdAt: string
}

export function savePendingPlanChange(input: {
  subscriptionId: string
  targetPlanId?: string | null
  createdAt?: string | null
}): PendingPlanChange | null {
  try {
    const subscriptionId = String(input.subscriptionId || '').trim()
    if (!subscriptionId) return null
    const createdAt = input.createdAt ? String(input.createdAt) : new Date().toISOString()
    const targetPlanId = input.targetPlanId ? String(input.targetPlanId).trim() : null
    const payload: PendingPlanChange = { subscriptionId, targetPlanId, createdAt }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(payload))
    return payload
  } catch {
    return null
  }
}

export function getPendingPlanChange(): PendingPlanChange | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as Partial<PendingPlanChange> & Record<string, any>
    const subscriptionId = String(parsed.subscriptionId || parsed.subscription_id || '').trim()
    const createdAt = String(parsed.createdAt || parsed.created_at || '').trim()
    if (!subscriptionId || !createdAt) {
      clearPendingPlanChange()
      return null
    }
    const createdMs = Date.parse(createdAt)
    if (!Number.isFinite(createdMs) || Date.now() - createdMs > MAX_AGE_MS) {
      clearPendingPlanChange()
      return null
    }
    const targetPlanRaw = parsed.targetPlanId ?? parsed.target_plan_id ?? null
    const targetPlanId = targetPlanRaw ? String(targetPlanRaw).trim() : null
    return { subscriptionId, targetPlanId, createdAt: new Date(createdMs).toISOString() }
  } catch {
    return null
  }
}

export function clearPendingPlanChange(): void {
  try {
    localStorage.removeItem(STORAGE_KEY)
  } catch {}
}
